<template>
    <div class="result-board">
        <div class="result-board-text" v-if="$store.state.pk.loser === 'all'">
            Draw
        </div>
        <div class="result-board-text"
            v-else-if="$store.state.pk.loser === 'A' && $store.state.pk.a_id === parseInt($store.state.user.id)">
            Lose
        </div>
        <div class="result-board-text"
            v-else-if="$store.state.pk.loser === 'B' && $store.state.pk.b_id === parseInt($store.state.user.id)">
            Lose
        </div>
        <div class="result-board-text" v-else>
            Win
        </div>
        <div class="result-board-btn">
            <button @click="restart" type="button" class="btn btn-warning btn-lg">
                再来一局
            </button>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex';
export default {
    setup() {
        const store = useStore();
        console.log(store.state.pk.a_id, store.state.pk.b_id, store.state.user.id);

        const restart = () => {
            store.commit("updateStatus", "matching");
            store.commit("updateLoser", "none");
            store.commit("updateOpponent", {
                username: "我的对手",
                photo: "https://cdn.acwing.com/media/article/image/2022/08/09/1_1db2488f17-anonymous.png",
            })
        }

        return {
            restart
        };
    }
}
</script>

<style scoped>
div.result-board {
    min-height: 260px;
    width: min(420px, calc(100% - 32px));
    background: var(--app-surface);
    border: 1px solid var(--app-border);
    border-radius: var(--app-radius-lg);
    box-shadow: var(--app-shadow);
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1800;
    transform: translate(-50%, -50%);
    backdrop-filter: blur(18px);
}

div.result-board-text {
    text-align: center;
    color: var(--app-text);
    font-size: 50px;
    font-style: italic;
    font-weight: 900;
    padding-top: 56px;
}

div.result-board-btn {
    text-align: center;
    padding-top: 46px;
}
</style>
